export class Phone {
  description!: string;
  type!: string;
  phone!: string | undefined | null;
  id!: string;
  editable!: boolean;
  sms!: boolean;
}
